import React, { FC, PropsWithChildren } from 'react';
import { MainContent, PageContent } from './Page.styled';

export const Page: FC<PropsWithChildren> = ({ children }) => (
  <PageContent>{children}</PageContent>
);

export const Main: FC<PropsWithChildren> = ({ children }) => (
  <MainContent id="scrollContainer">{children}</MainContent>
);
